import { Icon } from "@iconify/react/dist/iconify.js";

const MembersSection = ({ 
    currentOrgId, 
    orgMembers, 
    onEditUser, 
    onResetPassword, 
    onDeleteUser 
}) => {
    const renderMemberActions = (member) => (
        <div className="flex gap-2">
            <button
                onClick={() => onEditUser(member)}
                className="p-1 rounded group hover:bg-primary transition-colors"
                title="Edit User"
            >
                <Icon icon="lucide:edit" className="text-lg text-primary group-hover:text-background" />
            </button>
            <button
                onClick={() => onResetPassword(member.email)}
                className="p-1 rounded group hover:bg-yellow-500 transition-colors"
                title="Reset Password"
            >
                <Icon icon="lucide:key" className="text-lg text-yellow-500 group-hover:text-background" />
            </button>
            <button
                onClick={() => onDeleteUser(member.user_id)}
                className="p-1 rounded group hover:bg-error transition-colors"
                title="Delete User"
            >
                <Icon icon="lucide:trash" className="text-lg text-error group-hover:text-background" />
            </button>
        </div>
    );

    return (
        <div className="flex flex-col w-full h-full px-2 sm:px-3 rounded-lg">
            <div className="text-xl flex items-center gap-3 pb-3">
                <Icon icon="mdi:account-group" className="text-4xl text-primary" />
                <div>
                    <h3 className="font-semibold">Organization Members</h3>
                    <p className="text-sm text-font-secondary">{orgMembers[currentOrgId]?.length || 0} total members</p>
                </div>
            </div>
            {/* Adding padding and Removing Margin to show the shadow effect */}
            <div className="flex flex-col flex-1 p-1 sm:p-2 -m-1 sm:-m-2 overflow-y-auto gap-2">
                {orgMembers[currentOrgId]?.length > 0 ? (
                    orgMembers[currentOrgId].map(member => (
                        <div key={member.user_id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-3 p-2 sm:p-3 card-container hover:bg-background hover:card-container rounded-md sm:rounded-lg hover:bg-opacity-80 transition-all duration-300 ease-out  2xl:flex-row 2xl:items-center">
                            {/* Top section: Avatar and basic info */}
                            <div className="flex flex-row gap-2 sm:gap-3 items-center flex-1 min-w-0">
                                <img
                                    src={member.picture || `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name || member.email)}&background=00aeef&color=fff`}
                                    alt={member.name}
                                    className="w-10 h-10 sm:w-12 sm:h-12 rounded-md flex-shrink-0"
                                    onError={(e) => {
                                        e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.name || member.email)}&background=00aeef&color=fff`;
                                    }}
                                />
                                <div className="flex flex-col min-w-0 flex-1 gap-1">
                                    <span className="font-medium truncate text-font-primary text-sm sm:text-base">{member.name || 'No name'}</span>
                                    <span className="text-xs sm:text-sm text-font-secondary truncate">{member.email}</span>
                                </div>
                            </div>

                            {/* Bottom section: Role and actions */}
                            <div className="flex flex-row items-center justify-between gap-2 sm:gap-3 w-full sm:w-auto sm:flex-shrink-0">
                                {/* Role badge */}
                                <div className="flex-shrink-0">
                                    {member.roles && member.roles.length > 0 && (
                                        <span className="text-xs sm:text-xs text-accent button-container px-2 py-1 rounded">
                                            {member.roles[0].name}
                                        </span>
                                    )}
                                </div>

                                {/* Actions */}
                                <div className="flex-shrink-0">
                                    {renderMemberActions(member)}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center py-6 sm:py-8 text-font-secondary">
                        <Icon icon="mdi:account-off" className="text-3xl sm:text-4xl mb-2" />
                        <p className="italic text-sm sm:text-base">No members found</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MembersSection;
